import { render } from "./WidgetsTable.vue?vue&type=template&id=069a44e8"
import script from "./WidgetsTable.vue?vue&type=script&lang=js"
export * from "./WidgetsTable.vue?vue&type=script&lang=js"

import "./WidgetsTable.vue?vue&type=style&index=0&id=069a44e8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__